module.exports = __webpack_public_path__ + "img/annai_regi_sp_self.146fe025.gif";